/* Updated 12-23-2025 by Mike */

function pro_view_triggered(m2) {
	var status=m2||null,
	toggle_visibility="active";
	const container_status=jq_eig("#pro_container"),
	notice_status=jq_eig("#pro_container .result_notice"),
	search_form_status=jq_eig("#pro_container .pro_search_form"),
	content_status=jq_eig("#pro_container #pro_result_content");
	status=="search" &&(jq_eig(notice_status).toggleClass(toggle_visibility), jq_eig(search_form_status).toggleClass(toggle_visibility), jq_eig(content_status).toggleClass(toggle_visibility)),
	status=="search_back" &&(jq_eig("#pro_container .result_notice").empty().html('<span class="error same_value"><strong>ENTER ZIP:</strong> Provide the five digit zipcode of the address where you would have the appointment scheduled for.</span>'), jq_eig(notice_status).toggleClass(toggle_visibility), jq_eig(search_form_status).toggleClass(toggle_visibility), jq_eig(content_status).toggleClass(toggle_visibility)),
	status=="search_diff" &&(jq_eig("#pro_container .result_notice").empty().html('<span class="error same_value"><strong>ERROR:</strong> Same zipcode provided, try searching for a different zipcode.</span>'), jq_eig(notice_status).toggleClass(toggle_visibility), jq_eig(search_form_status).toggleClass(toggle_visibility), jq_eig(content_status).toggleClass(toggle_visibility))
}

function build_pro_results(response_data, type) {

	const r_ivr_phone="855-506-0775",
	r_append_campaign_values="self_booking",
	r_utm_source="saferacks",
	r_ivr_phone_link=r_ivr_phone.replace(/["("]|[")"]|-|\s/gi, ""),
	r_flags=response_data.flags,
	r_status=response_data.status,
	r_search=response_data.search,
	r_zip=response_data.zip,
	r_inst=response_data.inst,
	r_inv=response_data.inv,
	r_zone_1=response_data.zone_1,
	r_zone_2=response_data.zone_2,
	r_city=response_data.city,
	r_county=response_data.county,
	r_state=response_data.state,
	r_lat=response_data.lat,
	r_long=response_data.long,
	toggle_btn_list='<a id="toggle_markets" type="button" class="button primary is-smaller toggle-list" onclick="toggleListView()"><i class="icon-menu bt-icon"></i> <span>LIST VIEW</span></a>',
	scroll_btn_left='<a id="slideLeft" type="button" class="button primary is-smaller arrow-scroll" onclick="slideLeft()"><i class="icon-angle-left bt-icon"></i></a>',
	scroll_btn_right='<a id="slideRight" type="button" class="button primary is-smaller arrow-scroll" onclick="slideRight()"><i class="icon-angle-right bt-icon"></i></a>',
	r_rates_html=response_data.rates_html.length>0?toggle_btn_list+response_data.rates_html:"",
	r_status_map= {
		0:  !1, 1: !0, 2: !0, 3: !0, 4: !0, 5: !0, 6: !0, 7: !0, 8: !0
	}

	,
	r_number_map= {
		0: "no", 1:"one", 2:"two", 3:"three", 4:"four"
	}

	,
	r_inv_str=r_number_map[r_inv],
	r_inst_str=r_number_map[r_inst],
	r_inv_status=r_status_map[r_inv],
	r_inst_status=r_status_map[r_inst];
	var inventory_content="";

	if(r_flags.enable_notices== !0) {
		const global_notice=jq_eig("#pro_container .global_notice");
		jq_eig(global_notice).toggleClass("active")
	}

	if(r_flags.enable_booking== !1&&r_flags.enable_notices== !0||r_status=="inactive")var booking_notice_title=r_flags.notice_booking,
	booking_notice_message=r_flags.notice_booking_msg.length>3?r_flags.notice_booking_msg:response_data.status_message,
	booking_notice_html=`<h5 class="section-title section-title-center" data-text-color="secondary"><b></b><span class="section-title-main">${booking_notice_title}</span><b></b></h5><p style="font-size: 13px;">${booking_notice_message}</p>`,
	book_appt_section=`<div class="pro_installer_action">${booking_notice_html}</div>`;

	if(r_inst_status== !0) {
		var installer_content=`<div class="pro_installer_message"><p>Great news,
		we found <span class="underline">${r_inst_str}</span>installer(s) in the greater ${r_county} County,
		${r_state} area ! </p></div>`,
		book_appt_link=`<a href="https://appt.saferacks.com/installation/?appt_zipcode=${r_zip}&utm_source=${r_utm_source}&utm_campaign=${r_append_campaign_values}" target="_blank" class="button secondary is-outline is-xsmall booking-link" style="border-radius:53px;"><span>SCHEDULE ONLINE</span><i class="icon-angle-right"></i></a>`,
		book_appt_phone=`<div class="phone_set"><span class="phone_text">BOOK BY PHONE:</span><a href="tel:${r_ivr_phone_link}" target="_blank" class="button primary is-outline is-xsmall booking-phone" style="border-radius:53px;"><span>${r_ivr_phone}</span><i class="icon-angle-right"></i></a></div>`,
		market_rates_content=`<div class="pro_market rates">${scroll_btn_left} ${r_rates_html} ${scroll_btn_right}</div>`;
		if(r_flags.enable_booking== !0)var book_appt_section=`<div class="pro_installer_action">${book_appt_link} ${book_appt_phone}</div>`
	}

	if(r_inst_status== !1)var installer_content=`<div class="pro_installer_message"><p>Unfortunately,
	we do not currently have installers in your area.</p></div>`,
	book_appt_section="",
	market_rates_content="";
	if(r_inv_status== !0)var inventory_content=`<div class="pro_inv_message"><p>The prices below <i><b>include the product and installation cost</i></b>,
	but <b>do not</b>include any accessories,
	which the installers do have available for an additional charge.<p></div>`;
	if(r_inv_status== !1&&r_inst_status== !0)var inventory_content=`<div class="pro_inv_message"><p>Please make sure you have purchased your racks before your scheduled install date,
	if you already have them then you'll be good to go!</p>
 </div>`;
	return`<div class="search_response pro_query_response" data-query-param="${r_search}"><div class="pro_header"><a class="button primary is-smaller is-outline back_to_form" onclick="pro_view_triggered('search_back')" id="proBackSearch"><i class="icon-angle-left"></i>BACK</a><br/><br/><h4 class="result-header">SafeRacks Certified Installers <span class="status-${r_inst_status}">${r_zip}</span></h4></div>${installer_content} ${book_appt_section} ${inventory_content} ${market_rates_content} </div>`
}

function eig_pro_results_callback() {
	var is_ready= !1,
	endpoint="",
	pro_search=document.getElementById("pro-search-input").value,
	prev_search=jq_eig("#pro_result_content .pro_query_response").data("query-param");
	const zipcode=pro_search,
	type=jq_eig(this).data("type"),
	gvid=jq_eig(this).data("gvid"),
	pro_container_sel=jq_eig("#pro_container"),
	pro_results_container_sel=jq_eig("#pro_result_content");
	pro_search.length==5?(pro_search !=prev_search&&(is_ready= !0), pro_search==prev_search&&pro_view_triggered("search_diff")): pro_search=null;

	const r_endpoint= {
		domain: "api.eagleindustrialgroup.com", base:"wp-json", market:"eig_inst/v1/consumer?type=zipcode_pricing_gv_html&zipcode=" +zipcode+"&view_id=" +gvid, find_pro:"pro_install/v1/zipcode?type=zipinv&zipcode=" +zipcode
	}

	;

	is_ready== !0&&(jq_eig("#pro_search_spinner").css("display", "inline-block"), jq_eig.ajax({
			method:"GET", url:"https://" +r_endpoint.domain+"/" +r_endpoint.base+"/" +r_endpoint[type], data: {}

			, dataType:"json", success:function(response_data) {
				if(type=="find_pro")var flags=response_data.flags, process_content=build_pro_results(response_data, type); if(type=="market")var flags=response_data.flags, process_content=response_data.data; jq_eig(pro_results_container_sel).html(process_content), pro_view_triggered("search")
			}

			, complete:function() {
				jq_eig("#pro_search_spinner").hide()
			}

			, error:function(jqXHR, textStatus, errorThrown) {
				var msg=getXHRmessage(jqXHR, "getting market availability"); alert(msg)
			}
		}))
}

function getXHRmessage(jqXHR, operation) {
	var err_title=null,
	err_details=null;

	if(jqXHR.readyState) {
		var err_title_match=jqXHR.responseText.match(/<title>(.+)<\/title>/),
		err_details_match=jqXHR.responseText.match(/<p>(.+)<\/p>/);
		err_title_match===void 0||err_title_match==null?(err_title=`Code: ${jqXHR.status}, ${jqXHR.statusText}`, err_details=jqXHR.responseJSON.message): (err_title=err_title_match[1], err_details=err_details_match[1])
	}

	else err_title="Cannot Connect!",
	err_details="Either the internet connection is down, or the server isn't responding.";
	var msg=`An error occurred during the ${operation} operation. ${err_title} ${err_details} `;
	return msg
}

function build_pro_results_v2(response_data, type) {

	const r_ivr_phone="855-506-0775",
	r_append_campaign_values="self_booking",
	r_utm_source="saferacks",
	r_ivr_phone_link=r_ivr_phone.replace(/["("]|[")"]|-|\s/gi, ""),
	r_flags=response_data.flags,
	r_status=response_data.status,
	r_search=response_data.search,
	r_zip=response_data.zip,
	r_inst=response_data.inst,
	r_inv=response_data.inv,
	r_zone_1=response_data.zone_1,
	r_zone_2=response_data.zone_2,
	r_city=response_data.city,
	r_county=response_data.county,
	r_state=response_data.state,
	r_lat=response_data.lat,
	r_long=response_data.long,
	toggle_btn_list='<a id="toggle_markets" type="button" class="button primary is-smaller toggle-list" onclick="toggleListView()"><i class="icon-menu bt-icon"></i> <span>LIST VIEW</span></a>',
	scroll_btn_left='<a id="slideLeft" type="button" class="button primary is-smaller arrow-scroll" onclick="slideLeft()"><i class="icon-angle-left bt-icon"></i></a>',
	scroll_btn_right='<a id="slideRight" type="button" class="button primary is-smaller arrow-scroll" onclick="slideRight()"><i class="icon-angle-right bt-icon"></i></a>',
	r_rates_html=response_data.rates_html.length>0?toggle_btn_list+response_data.rates_html:"",
	io_overhead_price=response_data.io_overhead_price,
	io_retractable_racks_exclusion = '<p class="retractable_racks_price_exclusion">*Price excludes retractable racks. <br>Motorized and drill-powered storage lifts can be installed for $299/rack. <br>All non-SafeRacks brand overhead rack installations are $229/rack.</p>',
	r_status_map= {
		0:  !1, 1: !0, 2: !0, 3: !0, 4: !0, 5: !0, 6: !0, 7: !0, 8: !0
	}

	,
	r_number_map= {
		0: "no", 1:"one", 2:"two", 3:"three", 4:"four"
	}

	,
	r_inv_str=r_number_map[r_inv],
	r_inst_num_str=r_number_map[r_inst],
	r_inst_word=r_inst==1?"installer":"installers",
	r_inv_status=r_status_map[r_inv],
	r_inst_status=r_status_map[r_inst];
	var inventory_content="";
	window.eig_pro_is_inv_install="N";
	var back_button=`<a class="button primary is-smaller is-outline back_to_form" onclick="pro_view_triggered('search_back')" id="proBackSearch">BACK</a>`;

	if(r_flags.enable_notices== !0) {
		const global_notice=jq_eig("#pro_container .global_notice");
		jq_eig(global_notice).toggleClass("active")
	}

	if(r_flags.enable_booking== !1&&r_flags.enable_notices== !0||r_status=="inactive")var booking_notice_title=r_flags.notice_booking,
	booking_notice_message=r_flags.notice_booking_msg.length>3?r_flags.notice_booking_msg:response_data.status_message,
	booking_notice_html=`<h5 class="section-title section-title-center" data-text-color="secondary"><b></b><span class="section-title-main">${booking_notice_title}</span><b></b></h5><p style="font-size: 13px;">${booking_notice_message}</p>`,
	book_appt_section=`<div class="pro_installer_action_v2">${booking_notice_html}</div>`;

	if(r_inst_status== !0) {
		window.eig_pro_book_appt_url=`https://appt.saferacks.com/installation/?appt_zipcode=${r_zip}&gfnext=34_57&utm_source=${r_utm_source}&utm_campaign=${r_append_campaign_values}`;var installer_content='<div class="pro_installer_message"><p>Great news, we offer installation in your area! </p></div>',book_appt_link='<a class="button is-xsmall booking-link" onclick="eig_pro_book_online_callback(event)"><span>BOOK ONLINE</span><i class="icon-angle-right"></i></a>',book_appt_phone=`<div class="phone_set"><a href="tel:${r_ivr_phone_link}" target="_blank" class="button primary is-outline is-xsmall booking-phone" style="border-radius:53px;"><span>${r_ivr_phone}</span><i class="icon-angle-right"></i></a></div>`,market_rates_content=`<div class="pro_market rates">${scroll_btn_left} ${r_rates_html} ${scroll_btn_right}</div>`;if(r_flags.enable_booking==!0)var book_appt_section=`<div class="pro_installer_action_v2">${book_appt_link} ${book_appt_phone}</div>`}else var installer_content=`<div class="pro_installer_message">
		<p>Unfortunately,
		we do not currently have installers in your area.</p></div>`,
		book_appt_section="",
		market_rates_content="";
		const book_next_button='<button id="book_next_button" type="button" class="button btn btn-primary is-xsmall" style="border-radius:53px;" onclick="eig_pro_book_online_callback(event)">NEXT</button>';

		if(r_inv_status== !0)if(1) {
			var result_header_style="",
			select_style="";
			window.innerWidth<375?(result_header_style='style = "font-size: 14px;"', select_style='style = "font-size: 10px;"'): window.innerWidth<412?select_style='style = "font-size: 12px;"':window.innerWidth<500&&(select_style='style = "font-size: 14px;"');
			var inventory_content=`<div id="pro_install_type"><div id="pro_install_type_wrapper"><select id="pro_install_is_inv_select"${select_style} onchange="eig_pro_install_type_select_callback(event)"><option value="" selected>What type of installation do you need?</option><option value="N">I have product,
			only need installation ($${io_overhead_price}*/rack)</option><option value="Y">I may need installer provided product</option></select></div></div>`
		}

		else var inventory_content;
		else if(r_inv_status== !1&&r_inst_status== !0) {
			var inventory_content=`<div class="pro_inv_message"><p>Please ensure that all racks to be installed are at your address before the installation date. The rack installation fee is <span id="io_overhead_price">$${io_overhead_price}*</span>/rack. The installer does not provide racks or other products. Thank you!</p></div>`;
			setTimeout(() => {
				jq_eig(".retractable_racks_price_exclusion").toggle(1);
			}, 500);
		}
		return`<div class="search_response pro_query_response" data-query-param="${r_search}"><div class="pro_header"><h4 class="result-header"${result_header_style}>Installers <span class="status-${r_inst_status}">${r_zip}</span></h4>${back_button} </div>${installer_content} ${inventory_content} ${io_retractable_racks_exclusion} ${book_appt_section} ${market_rates_content} </div>`
	}

	function eig_pro_install_type_radio_callback(e) {
		window.eig_pro_is_inv_install=jq_eig("#pro_install_type input[name='pro_install_is_inv_radio']:checked").val();
		const show_pro_market=window.eig_pro_is_inv_install=="Y";
		jq_eig(".pro_market").toggle(show_pro_market)
	}

	function eig_pro_install_type_select_callback(e) {
		const pro_install_is_inv_select_val=jq_eig("#pro_install_is_inv_select").val();
		window.eig_pro_is_inv_install=pro_install_is_inv_select_val=="Y" ?"Y": "N";
		const show_pro_market=window.eig_pro_is_inv_install=="Y";
		const show_pro_io_retractable_exclusion=pro_install_is_inv_select_val=="N";
		jq_eig(".pro_market").toggle(show_pro_market);
		jq_eig(".retractable_racks_price_exclusion").toggle(show_pro_io_retractable_exclusion);
	}

	function eig_pro_book_online_callback(e) {
		if(jq_eig("#pro_install_is_inv_select").val()=="")alert("You must select the type of installation via the drop-down before proceeding.");

		else {
			const book_appt_url=eig_pro_book_appt_url+`&inv_install=${eig_pro_is_inv_install}`;
			window.open(book_appt_url, "_blank")
		}
	}

	function eig_pro_results_callback_v2() {
		var is_ready= !1,
		endpoint="",
		pro_search=document.getElementById("pro-search-input").value,
		prev_search=jq_eig("#pro_result_content .pro_query_response").data("query-param");
		const zipcode=pro_search,
		type=jq_eig(this).data("type"),
		pro_container_sel=jq_eig("#pro_container"),
		pro_results_container_sel=jq_eig("#pro_result_content");
		pro_search.length==5?(pro_search !=prev_search&&(is_ready= !0), pro_search==prev_search&&pro_view_triggered("search_diff")): pro_search=null;

		const r_endpoint= {
			domain: "api.eagleindustrialgroup.com", base:"wp-json", find_pro:"pro_install/v2/zipcode?type=zipinv&zipcode=" +zipcode
		}

		;

		is_ready== !0&&(jq_eig("#pro_search_spinner").css("display", "inline-block"), jq_eig.ajax({
				method:"GET", url:"https://" +r_endpoint.domain+"/" +r_endpoint.base+"/" +r_endpoint[type], data: {}

				, dataType:"json", success:function(response_data) {
					if(type=="find_pro")var flags=response_data.flags, process_content=build_pro_results_v2(response_data, type); jq_eig(pro_results_container_sel).html(process_content), jq_eig(".pro_market").hide(), jq_eig("div.rte p").eq(0).hide(), jq_eig("section.section-image-with-text-overlay").hide(), jq_eig("h1.h2").css("font-size", "20px"), jq_eig("#install_pro_container").css("margin-top", "-30px"), jq_eig("#install_pro_container").closest("section").removeClass("border-top"), jq_eig("#pro_result_content .nav-tabs .nav-link").on("show.bs.tab", function(e) {
							jq_eig("#pro_result_content .nav-tabs .nav-link").removeAttr("style")
						}), pro_view_triggered("search")
				}

				, complete:function() {
					jq_eig("#pro_search_spinner").hide()
				}

				, error:function(jqXHR, textStatus, errorThrown) {
					var msg=getXHRmessage(jqXHR, "getting market availability"); alert(msg)
				}
			}))
}

jq_eig(document).ready(function() {
		if(1) {
			var proEventSearch=document.getElementById("pro-search-input"); if(proEventSearch) {
				var proButtonClick=document.getElementById("proButtonClick"); proButtonClick.addEventListener("click", eig_pro_results_callback_v2)
			}
		}

		else {
			var proEventSearch; if(proEventSearch)var proButtonClick
		}

		jq_eig("#proBackSearch").click(function() {
				pro_view_triggered(m="search")
			})
	});
//# sourceMappingURL=/s/files/1/0657/7487/8934/t/8/assets/search_pro.js.map?v=1711065500
// line 24: <label id="select_install_type_prompt">Select your type of installation:</label><br/>